import { paymentToPence } from "../Functions/functions.js";

let apiUrl;
if (process.env.NODE_ENV !== "production") {
  require("dotenv").config();
  apiUrl = process.env.REACT_APP_API_URL;
} else {
  apiUrl = "https://us-central1-reforest-the-world.cloudfunctions.net/api";
}

export const getForestDonations = async () => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  console.log("request to db sent");
  const rawResponse = await fetch(`${apiUrl}/getDonations`, {
    method: "GET",
    headers: headers,
  });
  const forestData = await rawResponse.json();
  return forestData.data;
};

export const setupStripe = async () => {
  const rawResponse = await fetch(`${apiUrl}/setupStripe`, {
    method: "GET",
  });
  return await rawResponse.json();
};

export const makePaymentIntent = async (donationAmount) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const rawResponse = await fetch(`${apiUrl}/makePaymentIntent`, {
    method: "POST",
    body: JSON.stringify({ amount: paymentToPence(donationAmount) }),
    headers: headers,
  });
  return await rawResponse.json();
};
